import './accordions.scss';

document.addEventListener('DOMContentLoaded', function () {
	console.warn('loaded');
	document.querySelectorAll('.accordion-summary').forEach(summary => {
		summary.addEventListener('click', () => {
			console.warn('clicked');
			const accordionDetails = summary.closest('.accordion-details');
			const isOpen = accordionDetails.getAttribute('data-open') === 'true';

			// Toggle the data-open attribute of the accordion details
			accordionDetails.setAttribute('data-open', !isOpen);

			// Also toggle the aria-expanded attribute of the accordion summary
			summary.setAttribute('aria-expanded', !isOpen);
		});
	});
});